export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative w-full py-10 md:py-14 border-t border-white/10"
    >
      <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 xl:px-24 grid grid-cols-12 gap-6 items-end">
        <div className="col-span-12 md:col-span-4 flex items-center gap-3">
          <div className="w-2 h-2 bg-[#d4ff00] rounded-full" />
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white">
            Ziraminds AI &nbsp;©&nbsp; {new Date().getFullYear()}
          </span>
        </div>
        <div className="col-span-6 md:col-span-4">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#4a4a4a]">
            Crafted in Chennai / for Earth
          </span>
        </div>
        <div className="col-span-6 md:col-span-4 text-right">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#4a4a4a]">
            All systems nominal
          </span>
        </div>
      </div>
    </footer>
  );
}
